<template>
  <div>
    <v-btn color="green lighten-2" text @click="openModal()">
      Choose Image
    </v-btn>
    <v-dialog floating absolute v-model="drawer" class="">
      <v-container fluid class="white media-popup">
        <v-row>
          <v-col class="col-8" style="overflow:scroll; max-height: 90vh;">
            <v-row v-if="files.length > 0">
              <!-- card -->
              <v-col
                class="col-12 col-lg-3"
                v-for="index in files.length"
                :key="index"
                elevation="2"
              >
                <a @click.stop="mediaInfo(index)">
                  <v-card>
                    <div
                      class="col p-0 m-0"
                      :style="{
                        backgroundImage: `url('${files[index - 1].url}')`,
                        backgroundSize: `cover`,
                        backgroundRepeat: `no-repeat`,
                        backgroundPosition: `center center`,
                        height: `200px`,
                      }"
                    ></div>
                  </v-card>
                </a>
              </v-col>
              <!-- Card -->
            </v-row>
          </v-col>
          <v-col class="col-4" v-if="files.length > 0 && selected">
            <v-row>
              <v-col cols="12">
                <v-card>
                  <div
                    class="col p-0 m-0"
                    :style="{
                      backgroundImage: `url('${files[currentIndex].url}')`,
                      backgroundSize: `cover`,
                      backgroundRepeat: `no-repeat`,
                      backgroundPosition: `center center`,
                      height: `50vh`,
                    }"
                  ></div>
                </v-card>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  disabled
                  label="File Name"
                  v-model="files[currentIndex].name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="d-flex justify-end">
                <v-col class="text-right">
                  <v-btn color="green lighten-2" text @click="selectImage">
                    Ok
                  </v-btn>
                  <v-btn color="red lighten-2" text @click="reset">
                    Cancel
                  </v-btn>
                </v-col>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { firebaseApp } from "@/config/firebase";
import firebase from "firebase/app";
const db = firebase.firestore(firebaseApp);
import EventBus from "../../config/eventBus";

export default {
  name: "MediaPopUp",
  data: () => ({
    drawer: false,
    currentIndex: 0,
    files: [],
    selected: false,
  }),
  methods: {
    reset() {
      this.drawer = false;
      this.selected = false;
    },
    selectImage() {
      EventBus.$emit("IMAGE_PICKED", this.files[this.currentIndex]);
      this.drawer = false;
      this.selected = false;
    },
    mediaInfo(index) {
      this.currentIndex = index - 1;
      this.selected = true;
    },

    openModal() {
      this.getValues();
      this.drawer = !this.drawer;
    },
    getValues() {
      let self = this;
      self.files = [];

      var storageRef = firebase.storage().ref("medias");
      storageRef
        .listAll()
        .then(function(result) {
          result.items.forEach(function(imageRef) {
            let object = imageRef;
            imageRef
              .getDownloadURL()
              .then(function(url) {
                // TODO: Display the image on the UI
                object.url = url;
                //console.log("object.url", object.url);
                imageRef
                  .getMetadata()
                  .then((metadata) => {
                    object.metadata = metadata;
                    self.files.push(object);

                    // sort by name
                    self.files.sort(function(a, b) {
                      var nameA = a.metadata.timeCreated;
                      var nameB = b.metadata.timeCreated;
                      if (nameA < nameB) {
                        return 1;
                      }
                      if (nameA > nameB) {
                        return -1;
                      }
                      return 0;
                    });
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              })
              .catch(function(error) {
                console.log(error);
              });
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.media-popup {
  z-index: 9999;
}
</style>
